/**
 * Whether any delivery day is enabled.
 *
 * `buildCutoffTimes` skips every disabled day, so a distributor with none
 * produces an empty `cutoffTimes` map. The backend rejects that, the mutation
 * comes back null, and the only thing the reader saw was "delivery settings could
 * not be updated" with no mention of the day they had just switched off.
 *
 * Guarding here means the form says what is wrong before the save, rather than the
 * backend saying it afterwards in its own words.
 */
export const hasAnyDeliveryDay = (
  deliveryDays?: Record<string, boolean> | null
): boolean => Object.values(deliveryDays ?? {}).some(Boolean);
